import { render } from "./ArchiveSvgIcon.vue?vue&type=template&id=66ec20e4"
import script from "./ArchiveSvgIcon.vue?vue&type=script&lang=js"
export * from "./ArchiveSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__